module.exports = __webpack_public_path__ + "static/img/18.779eeb6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/18.png
// module id = bE8O
// module chunks = 0